import { render } from "./UpgradeSubscription.vue?vue&type=template&id=06eea17a"
import script from "./UpgradeSubscription.vue?vue&type=script&lang=js"
export * from "./UpgradeSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__